export default () => ({
    iz_insertZone: {
        visible: false,
        position: { top: 0, left: 0, width: 0 },
        context: null
    },
    iz_insertZoneHoverIntent: null,
    iz_isOverInsertZone: false,
    iz_pendingInsertZone: null,
    iz_pendingMetricContext: null,
    iz_pendingRow: null,
    
    iz_isCreatingSection: false,
    iz_sectionCreationQueue: [],
    iz_queueCheckInterval: null,
    
    iz_cachedMetricOptions: null,
    iz_boundHandleMetricSelected: null,
    iz_boundHandleDocumentClick: null,
    iz_ignoreOutsideClickUntil: 0,
    iz_isPendingMetricInsertActive: false,
    
    iz_initInsertZones() {
        
        // Only initialize if we're in customize mode
        if (!this.showCustomizePanel) {
            return;
        }
        
        // Use querySelector since the ref is in a child Blade component
        const container = document.querySelector('[data-scorecard-scrollable-container-customize-left]');
        if (!container) {
            console.error('[INSERT_ZONES] Container not found with selector [data-scorecard-scrollable-container-customize-left]');
            return;
        }
        
        container.addEventListener('mouseenter', (e) => {
            const zone = e.target.closest('[data-insert-zone]');
            if (zone) {
                this.iz_handleZoneEnter(zone);
            }
        }, true);
        
        container.addEventListener('mouseleave', (e) => {
            const zone = e.target.closest('[data-insert-zone]');
            if (zone) {
                this.iz_handleZoneLeave(zone);
            }
        }, true);
        
        if (!this.iz_boundHandleMetricSelected) {
            this.iz_boundHandleMetricSelected = (e) => {
                this.iz_handleMetricSelected(e.detail.metricId, e.detail.metricName, e.detail.context);
            };
        }
        window.addEventListener('inline_metric_selected', this.iz_boundHandleMetricSelected);

        this.iz_registerPendingRowOutsideClickHandler();
    },

    iz_registerPendingRowOutsideClickHandler() {
        if (this.iz_boundHandleDocumentClick) return;

        this.iz_boundHandleDocumentClick = (e) => {
            const clickTarget = e.target;
            setTimeout(() => {
                if (!this.showCustomizePanel) return;
                if (!this.iz_pendingRow?.id) return;
                if (Date.now() < this.iz_ignoreOutsideClickUntil) return;
                if (!this.iz_isPendingMetricInsertActive) return;

                const overlay = document.querySelector('[data-pending-metric-selector-overlay]');
                if (!overlay) return;

                // If clicked inside the selector overlay, bail
                if (clickTarget && clickTarget.closest && clickTarget.closest('[data-pending-metric-selector-overlay]')) return;

                // bail if the click was inside the pending row container.
                const pendingRowContainer = document.querySelector(`[data-pending-row-id='${this.iz_pendingRow.id}']`);
                if (pendingRowContainer && clickTarget && pendingRowContainer.contains(clickTarget)) return;

                this.iz_cancelPendingRow();
            }, 100);
        };

        document.addEventListener('click', this.iz_boundHandleDocumentClick, true);
    },
    
    iz_handleZoneEnter(zoneElement) {
        clearTimeout(this.iz_insertZoneHoverIntent);
        
        const rect = zoneElement.getBoundingClientRect();
        const container = document.querySelector('[data-scorecard-scrollable-container-customize-left]');
        if (!container) return;
        
        const containerRect = container.getBoundingClientRect();
        
        const zoneType = zoneElement.dataset.insertZone;
        const sectionId = zoneElement.dataset.sectionId;
        const rowId = zoneElement.dataset.rowId;
        
        let context;
        if (zoneType === 'row' && rowId) {
            context = {
                type: 'row',
                rowId,
                sectionId,
                edge: 'bottom'
            };
        } else if (zoneType === 'section' && sectionId) {
            context = {
                type: 'section',
                sectionId,
                edge: 'bottom'
            };
        }
        
        this.iz_pendingInsertZone = {
            position: {
                top: rect.top,
                left: containerRect.left,
                width: containerRect.width
            },
            context
        };
        
        this.iz_insertZoneHoverIntent = setTimeout(() => {
            if (this.iz_pendingInsertZone) {
                this.iz_insertZone.position = this.iz_pendingInsertZone.position;
                this.iz_insertZone.context = this.iz_pendingInsertZone.context;
                requestAnimationFrame(() => {
                    this.iz_insertZone.visible = true;
                });
                
                this.iz_pendingInsertZone = null;
            }
        }, 150);
    },
    
    iz_handleZoneLeave(zoneElement) {
        clearTimeout(this.iz_insertZoneHoverIntent);
        this.iz_pendingInsertZone = null;
        
        setTimeout(() => {
            if (!this.iz_isOverInsertZone) {
                this.iz_hideInsertZone();
            }
        }, 50);
    },
    
    iz_hideInsertZone() {
        this.iz_insertZone.visible = false;
    },
    
    iz_handleInsertAction(action) {
        const context = this.iz_insertZone.context;
        
        if (action === 'section') {
            this.iz_insertSection(context);
        } else if (action === 'metric') {
            this.iz_isPendingMetricInsertActive = true;
            this.iz_ignoreOutsideClickUntil = Date.now() + 200;
            this.iz_insertMetric(context);
        }
        
        this.iz_hideInsertZone();
    },
    
    iz_insertSection(context) {
        if (!context || !context.sectionId) {
            console.error('Invalid context for section insertion:', context);
            return;
        }
        
        if (context.sectionId === 'GHOST') {
            return;
        }
        
        let scorecard_sections = (this.fullScorecardData?.sections || [])
            .filter(s => s.name !== 'GHOST')
            .sort((a, b) => a.order - b.order);
        
        const targetSectionIndex = scorecard_sections.findIndex(s => String(s.id) === String(context.sectionId));
        
        if (targetSectionIndex === -1) {
            return;
        }
        
        const hasPendingSections = scorecard_sections
            .some(s => typeof s.id === 'string' && s.id.startsWith('temp_'));
        
        if (hasPendingSections || this.iz_isCreatingSection) {
            this.iz_sectionCreationQueue.push(context);
            this.iz_startQueueProcessor();
            return;
        }
        
        this.iz_isCreatingSection = true;
        
        scorecard_sections = scorecard_sections.map((section, index) => ({
            ...section,
            order: index
        }));
        
        const targetSection = scorecard_sections[targetSectionIndex];
        
        let newSectionOrder;
        if (context.edge === 'top') {
            newSectionOrder = targetSection.order;
            scorecard_sections = scorecard_sections.map(section => {
                if (section.order >= newSectionOrder) {
                    return { ...section, order: section.order + 1 };
                }
                return section;
            });
        } else {
            newSectionOrder = targetSection.order + 1;
            scorecard_sections = scorecard_sections.map(section => {
                if (section.order >= newSectionOrder) {
                    return { ...section, order: section.order + 1 };
                }
                return section;
            });
        }
        
        const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const newSection = {
            id: tempId,
            name: 'Untitled section',
            expanded: true,
            order: newSectionOrder,
            scorecard_id: this.scorecard['id'],
            rows: []
        };

        scorecard_sections.push(newSection);
        
        scorecard_sections.sort((a, b) => a.order - b.order);
        
        this.fullScorecardData = {
            ...this.fullScorecardData,
            sections: [...scorecard_sections]
        };

        this.sortKey++;
        this.updateFilteredSections();

        const sectionsData = scorecard_sections.map(section => ({
            id: section.id,
            name: section.name,
            order: section.order,
            expanded: section.expanded,
            scorecard_id: section.scorecard_id
        }));

        this.$wire.call('createSectionWithOrdersUpdate', sectionsData)
            .then((response) => {
                if (response.success && response.new_section_id) {
                    // Replace temporary ID with real ID from backend
                    const sections = this.fullScorecardData?.sections || [];
                    const sectionIndex = sections.findIndex(s => s.id === tempId);
                    
                    if (sectionIndex !== -1) {
                        sections[sectionIndex].id = response.new_section_id;
                        this.fullScorecardData = {
                            ...this.fullScorecardData,
                            sections: [...sections]
                        };
                        
                        this.updateFilteredSections();
                        
                        // Focus on the newly created section's name input
                        this.$nextTick(() => {
                            const sectionInput = document.getElementById(`section-name-${response.new_section_id}`);
                            if (sectionInput) {
                                sectionInput.focus();
                                sectionInput.select();
                            }
                        });
                    }
                }
                
                this.iz_isCreatingSection = false;
                
                this.iz_processNextInQueue();
            })
            .catch((error) => {
                console.error('Error creating section:', error);
                const sections = this.fullScorecardData?.sections || [];
                const filteredSections = sections.filter(s => s.id !== tempId);
                this.fullScorecardData = {
                    ...this.fullScorecardData,
                    sections: filteredSections
                };
                this.updateFilteredSections();
                
                this.iz_isCreatingSection = false;
                
                this.iz_processNextInQueue();
            });
    },
    
    iz_createFirstSection() {
        if (this.iz_isCreatingSection) {
            return Promise.reject('Section creation in progress');
        }
        
        this.iz_isCreatingSection = true;
        
        const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const newSection = {
            id: tempId,
            name: 'Untitled section',
            expanded: true,
            order: 0,
            scorecard_id: this.scorecard['id'],
            rows: []
        };

        const scorecard_sections = (this.fullScorecardData?.sections || [])
            .filter(s => s.name !== 'GHOST');
        
        scorecard_sections.push(newSection);
        
        this.fullScorecardData = {
            ...this.fullScorecardData,
            sections: [...scorecard_sections]
        };

        this.sortKey++;
        this.updateFilteredSections();

        const sectionsData = [{
            id: newSection.id,
            name: newSection.name,
            order: newSection.order,
            expanded: newSection.expanded,
            scorecard_id: newSection.scorecard_id
        }];

        return this.$wire.call('createSectionWithOrdersUpdate', sectionsData)
            .then((response) => {
                if (response.success && response.new_section_id) {
                    // Replace temporary ID with real ID from backend
                    const sections = this.fullScorecardData?.sections || [];
                    const sectionIndex = sections.findIndex(s => s.id === tempId);
                    
                    if (sectionIndex !== -1) {
                        sections[sectionIndex].id = response.new_section_id;
                        this.fullScorecardData = {
                            ...this.fullScorecardData,
                            sections: [...sections]
                        };
                        
                        // Update filtered sections with the real ID
                        this.updateFilteredSections();
                        
                        // Focus on the newly created section's name input
                        this.$nextTick(() => {
                            const sectionInput = document.getElementById(`section-name-${response.new_section_id}`);
                            if (sectionInput) {
                                sectionInput.focus();
                                sectionInput.select();
                            }
                        });
                    }
                }
                
                // Mark creation as complete
                this.iz_isCreatingSection = false;
                
                return response;
            })
            .catch((error) => {
                console.error('Error creating first section:', error);
                const sections = this.fullScorecardData?.sections || [];
                const filteredSections = sections.filter(s => s.id !== tempId);
                this.fullScorecardData = {
                    ...this.fullScorecardData,
                    sections: filteredSections
                };
                this.updateFilteredSections();
                
                // Mark creation as complete
                this.iz_isCreatingSection = false;
                
                throw error;
            });
    },
    
    iz_startQueueProcessor() {
        if (this.iz_queueCheckInterval) return;
        
        this.iz_queueCheckInterval = setInterval(() => {
            if (!this.iz_isCreatingSection && this.iz_sectionCreationQueue.length === 0) {
                clearInterval(this.iz_queueCheckInterval);
                this.iz_queueCheckInterval = null;
            }
        }, 100);
    },
    
    iz_processNextInQueue() {
        if (this.iz_sectionCreationQueue.length > 0 && !this.iz_isCreatingSection) {
            const nextContext = this.iz_sectionCreationQueue.shift();
            setTimeout(() => this.iz_insertSection(nextContext), 50);
        }
    },
    
    iz_insertMetric(context) {
        if (!context) {
            console.error('[INSERT_ZONE] Invalid context for metric insertion:', context);
            return;
        }
        
        this.iz_createPendingRow(context);
    },
    
    iz_createPendingRow(context) {
        if (this.iz_pendingRow) {
            this.iz_cancelPendingRow();
        }
        
        let sectionId, insertOrder;
        
        const allRows = this.fullScorecardData?.rows || [];
        
        if (context.type === 'row') {
            sectionId = parseInt(context.sectionId);
            
            const targetRow = allRows.find(r => String(r.id) === String(context.rowId));
            
            if (!targetRow) {
                console.error('[INSERT_ZONE] Target row not found for id:', context.rowId);
                return;
            }
            
            if (context.edge === 'top') {
                insertOrder = targetRow.order;
                
                this.fullScorecardData.rows = allRows.map(row => {
                    if (parseInt(row.scorecard_section_id) === sectionId && row.order >= insertOrder) {
                        return { ...row, order: row.order + 1 };
                    }
                    return row;
                });
            } else {
                insertOrder = targetRow.order + 1;
                
                this.fullScorecardData.rows = allRows.map(row => {
                    if (parseInt(row.scorecard_section_id) === sectionId && row.order >= insertOrder) {
                        return { ...row, order: row.order + 1 };
                    }
                    return row;
                });
            }
            
        } else if (context.type === 'section') {
            sectionId = parseInt(context.sectionId);
            
            const sectionRows = allRows.filter(r => parseInt(r.scorecard_section_id) === sectionId);
            
            insertOrder = 0;
            
            if (sectionRows.length > 0) {
                this.fullScorecardData.rows = allRows.map(row => {
                    if (parseInt(row.scorecard_section_id) === sectionId) {
                        return { ...row, order: row.order + 1 };
                    }
                    return row;
                });
            }
        }
        
        const tempRowId = `temp_pending_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const pendingRow = {
            id: tempRowId,
            metric_id: null,
            display_name: 'Select a metric...',
            order: insertOrder,
            scorecard_section_id: sectionId,
            isPending: true
        };
        
        this.iz_pendingRow = {
            ...pendingRow,
            context: context
        };
        
        this.fullScorecardData = {
            ...this.fullScorecardData,
            rows: [...this.fullScorecardData.rows, pendingRow]
        };
        
        this.sortKey++;
        this.updateFilteredSections();
        
        this.$nextTick(() => {
            window.dispatchEvent(new CustomEvent('iz_activate_pending_row_selector', {
                detail: {
                    rowId: tempRowId,
                    context: context
                }
            }));
        });
    },
    
    iz_showInlineMetricSelector(context) {
        this.iz_pendingMetricContext = context;
        
        window.dispatchEvent(new CustomEvent('iz_show_metric_selector', {
            detail: {
                context: context,
                position: this.iz_insertZone.position
            }
        }));
        
        this.iz_hideInsertZone();
    },
    
    iz_handleMetricSelected(metricId, metricName, context) {
        if (!metricId) return;
        
        if (this.iz_pendingRow) {
            const { context: pendingContext } = this.iz_pendingRow;
            const sectionId = this.iz_pendingRow.scorecard_section_id;
            const order = this.iz_pendingRow.order;
            
            this.iz_removePendingRow(this.iz_pendingRow.id);
            
            this.iz_createRowInSection(metricId, metricName, sectionId, order);
            this.refreshMetricPermission(metricId);

            this.iz_pendingRow = null;
            this.iz_isPendingMetricInsertActive = false;
            return;
        }
    },
    
    iz_removePendingRow(rowId) {
        this.fullScorecardData = {
            ...this.fullScorecardData,
            rows: this.fullScorecardData.rows.filter(row => row.id !== rowId)
        };
        
        this.sortKey++;
        this.updateFilteredSections();
    },
    
    iz_cancelPendingRow() {
        if (this.iz_pendingRow) {
            this.iz_removePendingRow(this.iz_pendingRow.id);
            this.iz_pendingRow = null;
            this.iz_isPendingMetricInsertActive = false;
            
            window.dispatchEvent(new CustomEvent('iz_pending_row_cancelled'));
        }
    },
    
    iz_getAvailableMetricsToAdd() {
        if (this.iz_cachedMetricOptions) {
             this.iz_dispatchMetricOptions(this.iz_cachedMetricOptions);
             return;
        }

        this.$wire.getAvailableMetricsToAdd()
            .then((results) => {
                this.iz_cachedMetricOptions = results;
                this.iz_dispatchMetricOptions(results);
            })
    },

    iz_dispatchMetricOptions(options) {
        window.dispatchEvent(new CustomEvent('scorecards_add_new_metric_update-select2-options', {
            detail: {
                id: 'scorecards_add_new_metric',
                options: options
            }   
        }));
        
        window.dispatchEvent(new CustomEvent('inline_metric_selector_update-select2-options', {
            detail: {
                id: 'inline_metric_selector',
                options: options
            }   
        }));
        
        window.dispatchEvent(new CustomEvent('pending_metric_selector_update-select2-options', {
            detail: {
                id: 'pending_metric_selector',
                options: options
            }   
        }));
    },
    
    iz_createMetricAtTop(metricId, metricName) {
        if (!metricId) return;
        
        const actualMetricId = metricId.toString().startsWith('metric_id_') 
            ? parseInt(metricId.replace('metric_id_', ''))
            : parseInt(metricId);
        
        const ghostRows = (this.fullScorecardData?.rows || [])
            .filter(r => !r.scorecard_section_id)
            .map(row => ({
                ...row,
                order: row.order + 1
            }));
        
        const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const newRow = {
            id: tempId,
            metric_id: actualMetricId,
            scorecard_id: this.scorecard.id,
            scorecard_section_id: null,
            order: 0,
            display_name: metricName,
            fetching: true
        };
        
        
        const allRows = [...this.fullScorecardData.rows];
        const rowIndex = allRows.findIndex(r => r.id === tempId);
        if (rowIndex === -1) {
            allRows.push(newRow);
        }
        
        ghostRows.forEach(ghostRow => {
            const idx = allRows.findIndex(r => r.id === ghostRow.id);
            if (idx !== -1) {
                allRows[idx].order = ghostRow.order;
            }
        });
        
        this.fullScorecardData = {
            ...this.fullScorecardData,
            rows: allRows
        };
        
        this.updateFilteredSections();
        
        const rowsData = [newRow, ...ghostRows].map(row => ({
            id: row.id,
            metric_id: row.metric_id,
            scorecard_id: row.scorecard_id,
            scorecard_section_id: row.scorecard_section_id,
            order: row.order,
            display_name: row.display_name
        }));
        
        this.$wire.call('createRowWithOrdersUpdate', null, rowsData)
            .then((response) => {
                if (response.success && response.new_row_id) {
                    const rows = this.fullScorecardData.rows;
                    const rowIndex = rows.findIndex(r => r.id === tempId);
                    
                    if (rowIndex !== -1) {
                        rows[rowIndex].id = response.new_row_id;
                        this.fullScorecardData = {
                            ...this.fullScorecardData,
                            rows: [...rows]
                        };
                        this.updateFilteredSections();
                    }

                    // Fetch metric metadata
                        this.$wire.call('getMetricData', actualMetricId)
                            .then((metricData) => {
                                if (metricData) {
                                    this.fullScorecardData.metrics = {
                                        ...this.fullScorecardData.metrics,
                                        [actualMetricId]: metricData
                                    };
                                    this.updateMetas();
                                    this.updateIsManualModeAllowed();

                                    // Update fetching state
                                    const rows = this.fullScorecardData.rows;
                                    const currentRowIndex = rows.findIndex(r => r.id === response.new_row_id);
                                    if (currentRowIndex !== -1) {
                                        rows[currentRowIndex].fetching = false;
                                        this.fullScorecardData = {
                                            ...this.fullScorecardData,
                                            rows: [...rows]
                                        };
                                    }
                                }
                            });
                }
            })
            .catch((error) => {
                console.error('Error creating row:', error);
                const allRows = this.fullScorecardData.rows
                    .filter(r => r.id !== tempId)
                    .map(row => {
                        if (!row.scorecard_section_id) {
                            const originalGhostRow = ghostRows.find(gr => gr.id === row.id);
                            if (originalGhostRow) {
                                return { ...row, order: originalGhostRow.order - 1 };
                            }
                        }
                        return row;
                    });
                
                this.fullScorecardData = {
                    ...this.fullScorecardData,
                    rows: allRows
                };
                this.updateFilteredSections();
            });
    },
    
    iz_createRowInSection(metricId, metricName, sectionId, order) {
        if (!metricId) return;
        
        const actualMetricId = metricId.toString().startsWith('metric_id_') 
            ? parseInt(metricId.replace('metric_id_', ''))
            : parseInt(metricId);
        
        const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const newRow = {
            id: tempId,
            metric_id: actualMetricId,
            scorecard_id: this.scorecard.id,
            scorecard_section_id: sectionId,
            order: order,
            display_name: metricName,
            fetching: true
        };
        
        const allRows = [...this.fullScorecardData.rows];
        allRows.push(newRow);
        
        this.fullScorecardData = {
            ...this.fullScorecardData,
            rows: allRows
        };
        
        this.updateFilteredSections();
        
        this.$nextTick(() => {
            const sectionRowsData = [];
            const scorecard_rows = this.fullScorecardData?.rows || [];
            
            const container = document.querySelector('[data-scorecard-scrollable-container-customize-left]');
            if (!container) {
                console.error('[INSERT_ZONES] Container not found in iz_createRowInSection');
                return;
            }
            
            // Find the specific section's row container using simple data attribute
            const sectionContainer = container.querySelector(`[data-section-rows-container][data-section-id='${sectionId}']`);
            
            if (!sectionContainer) {
                console.error('[INSERT_ZONES] Section container not found for section:', sectionId);
                return;
            }
            
            const rowElements = sectionContainer.querySelectorAll('[data-rowid]');
            
            rowElements.forEach((rowElement, index) => {
                const rowId = rowElement.dataset.rowid;
                const rowData = scorecard_rows.find(r => String(r.id) === rowId);
                
                if (rowData && rowData.id) {
                    sectionRowsData.push({
                        id: rowData.id,
                        metric_id: rowData.metric_id,
                        scorecard_id: rowData.scorecard_id,
                        scorecard_section_id: sectionId,
                        order: index,
                        display_name: rowData.display_name
                    });
                }
            });
            
            sectionRowsData.forEach(rowData => {
                const rowIndex = allRows.findIndex(r => r.id === rowData.id);
                if (rowIndex !== -1) {
                    allRows[rowIndex].order = rowData.order;
                }
            });
            
            this.fullScorecardData = {
                ...this.fullScorecardData,
                rows: [...allRows]
            };
            
            this.$wire.call('createRowWithOrdersUpdate', sectionId, sectionRowsData)
                .then((response) => {
                    if (response.success && response.new_row_id) {
                        const rows = this.fullScorecardData.rows;
                        const rowIndex = rows.findIndex(r => r.id === tempId);
                        
                        if (rowIndex !== -1) {
                            rows[rowIndex].id = response.new_row_id;
                            this.fullScorecardData = {
                                ...this.fullScorecardData,
                                rows: [...rows]
                            };
                            this.updateFilteredSections();
                        }

                        // Fetch metric metadata
                        this.$wire.call('getMetricData', actualMetricId)
                            .then((metricData) => {
                                if (metricData) {
                                    this.fullScorecardData.metrics = {
                                        ...this.fullScorecardData.metrics,
                                        [actualMetricId]: metricData
                                    };
                                    this.updateMetas();
                                    this.updateIsManualModeAllowed();

                                    // Update fetching state
                                    const rows = this.fullScorecardData.rows;
                                    const currentRowIndex = rows.findIndex(r => r.id === response.new_row_id);
                                    if (currentRowIndex !== -1) {
                                        rows[currentRowIndex].fetching = false;
                                        this.fullScorecardData = {
                                            ...this.fullScorecardData,
                                            rows: [...rows]
                                        };
                                    }
                                }
                            });
                    }
                })
                .catch((error) => {
                    console.error('[INSERT_ZONES] Error creating row:', error);
                    // Remove temporary row on error
                    const updatedRows = this.fullScorecardData.rows.filter(r => r.id !== tempId);
                    
                    this.fullScorecardData = {
                        ...this.fullScorecardData,
                        rows: updatedRows
                    };
                    this.updateFilteredSections();
                });
        });
    },
    
    iz_destroyInsertZones() {
        clearTimeout(this.iz_insertZoneHoverIntent);
        clearInterval(this.iz_queueCheckInterval);
        this.iz_pendingInsertZone = null;
        this.iz_sectionCreationQueue = [];
        this.iz_isCreatingSection = false;
        this.iz_cancelPendingRow();
        this.iz_hideInsertZone();

        if (this.iz_boundHandleMetricSelected) {
            window.removeEventListener('inline_metric_selected', this.iz_boundHandleMetricSelected);
            this.iz_boundHandleMetricSelected = null;
        }

        if (this.iz_boundHandleDocumentClick) {
            document.removeEventListener('click', this.iz_boundHandleDocumentClick, true);
            this.iz_boundHandleDocumentClick = null;
        }

        this.iz_isPendingMetricInsertActive = false;
    }
});
